<mat-grid-list [cols]="18" gutterSize="25px" rowHeight="220px" class="grid-list-space">
    <mat-grid-tile colspan="3" class="align-items-inherit">
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Scheduled Start:</mat-label>
            </span>
            <mat-form-field class="no-underline body-wrapper block">
                <input matInput class="input-wrapper" [ngModel]="selectedTpr.buildSchedStart | date:'M/d/y'" readonly
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('buildSchedStart')" />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Actual Start:</mat-label>
            </span>
            <mat-form-field class="display-field no-underline bg-yellow">
                <input matInput class="input-wrapper" [matDatepicker]="buildActualStartDatepicker2"
                    [(ngModel)]="selectedTpr.buildActualStart"
                    (dateChange)="onGenericFieldChange('buildActualStart',selectedTpr.buildActualStart)"
                    [disabled]="disabled || reSourced  || inActive || !fieldAuthorized('buildActualStart')" />
                <mat-datepicker-toggle matSuffix [for]="buildActualStartDatepicker2"></mat-datepicker-toggle>
                <mat-datepicker #buildActualStartDatepicker2></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Processing Complete:</mat-label>
            </span>
            <mat-form-field class="display-field no-underline bg-yellow">
                <input matInput class="input-wrapper" [matDatepicker]="processDateDatepicker2"
                    [(ngModel)]="selectedTpr.processDate"
                    [disabled]="disabled || reSourced  || inActive || !fieldAuthorized('processDate')"
                    (dateChange)="onGenericFieldChange('processDate',selectedTpr.processDate)" />
                <mat-datepicker-toggle matSuffix [for]="processDateDatepicker2"></mat-datepicker-toggle>
                <mat-datepicker #processDateDatepicker2></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Build Adj (days):</mat-label>
            </span>
            <searchable-autocomplete style="margin-top: -12px;" [options]="daysOpts" [exactMatch]="false"
                [numberInput]="true" filterBy="buildSource" [(selected)]="selectedTpr.buildWeeksAdj"
                [disabled]="disabled || reSourced  || inActive || !fieldAuthorized('buildWeeksAdj')"
                (select)="onGenericFieldChange('buildWeeksAdj',selectedTpr.buildWeeksAdj, true)">
            </searchable-autocomplete>
        </div>

    </mat-grid-tile>
    <mat-grid-tile colspan="2" class="align-items-inherit check-padding">
        <mat-checkbox #fabPercentage class="checkbox-format text-center checkbox-6b" color="primary"
            [checked]="selectedTpr.fabricationPerc === 100"
            [disabled]="!selectedTpr.buildActualStart || disabled || reSourced  || inActive || !fieldAuthorized('fabrication')"
            (change)="onFabCheckChange($event)">
            Complete
        </mat-checkbox>
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label> 20% Fab:</mat-label>
            </span>
            <mat-form-field class="display-field no-underline bg-yellow">
                <input matInput class="input-wrapper" type="number" [(ngModel)]="selectedTpr.fabricationPerc"
                    [disabled]="!selectedTpr.buildActualStart || disabled || reSourced  || inActive || !fieldAuthorized('fabrication')"
                    (change)="onFabPercChange(fabPercentage)" name="fabInput"
                    pattern="^$|^([0-9]|[1-9][0-9]|[1][0][0])?" required #fabInput="ngModel" />
                <div *ngIf="fabInput.errors && (fabInput.dirty || fabInput.touched)">
                    <div class="error-hint" [hidden]="!fabInput.errors.pattern">
                        Number should be between 0 and 100
                    </div>
                </div>
            </mat-form-field>
        </div>

    </mat-grid-tile>
    <mat-grid-tile colspan="2" class="align-items-inherit check-padding">
        <mat-checkbox #ncPerc class="checkbox-format text-center checkbox-6b" color="primary"
            [checked]="selectedTpr.ncPrgmPerc === 100"
            [disabled]="!selectedTpr.buildActualStart || disabled || reSourced  || inActive || !fieldAuthorized('ncPrgm')"
            (change)="onNcCheckChange($event)">
            Complete
        </mat-checkbox>
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label> 15% NC Program:</mat-label>
            </span>
            <mat-form-field class="block no-underline bg-yellow">
                <input matInput class="input-wrapper" type="number" [(ngModel)]="selectedTpr.ncPrgmPerc"
                    [disabled]="!selectedTpr.buildActualStart || disabled || reSourced || !fieldAuthorized('ncPrgm')"
                    (change)="onNcPercChange(ncPerc)" name="ncPrgmInput" pattern="^$|^([0-9]|[1-9][0-9]|[1][0][0])?"
                    required #ncPrgmInput="ngModel" />
                <div *ngIf="ncPrgmInput.errors && (ncPrgmInput.dirty || ncPrgmInput.touched)">
                    <div class="error-hint" [hidden]="!ncPrgmInput.errors.pattern">
                        Number should be between 0 and 100
                    </div>
                </div>
            </mat-form-field>
        </div>

    </mat-grid-tile>
    <mat-grid-tile colspan="2" class="align-items-inherit check-padding">
        <mat-checkbox #machineCheck class="checkbox-format text-center checkbox-6b" color="primary"
            [checked]="selectedTpr.machiningPerc === 100"
            [disabled]="!selectedTpr.buildActualStart || disabled || reSourced  || inActive || !fieldAuthorized('machining')"
            (change)="onMachineCheckChange($event)">
            Complete
        </mat-checkbox>
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label> 15% Machining:</mat-label>
            </span>
            <mat-form-field class="block no-underline bg-yellow">
                <input matInput class="input-wrapper" type="number" [(ngModel)]="selectedTpr.machiningPerc"
                    [disabled]="!selectedTpr.buildActualStart || disabled || reSourced || !fieldAuthorized('machining')"
                    (change)="onMachinePercChange(machineCheck)" name="machiningInput"
                    pattern="^$|^([0-9]|[1-9][0-9]|[1][0][0])?" required #machiningInput="ngModel" />
                <div *ngIf="machiningInput.errors && (machiningInput.dirty || machiningInput.touched)">
                    <div class="error-hint" [hidden]="!machiningInput.errors.pattern">
                        Number should be between 0 and 100
                    </div>
                </div>
            </mat-form-field>
        </div>

    </mat-grid-tile>
    <mat-grid-tile colspan="2" class="align-items-inherit check-padding">
        <mat-checkbox #assemblyCheck class="checkbox-format text-center checkbox-6b" color="primary"
            [checked]="selectedTpr.assemblyPerc === 100"
            [disabled]="!selectedTpr.buildActualStart || disabled || reSourced  || inActive || !fieldAuthorized('assembly')"
            (change)="onAssemblyCheckChange($event)">
            Complete
        </mat-checkbox>
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label> 20% Assembly:</mat-label>
            </span>
            <mat-form-field class="block no-underline bg-yellow">
                <input matInput class="input-wrapper" type="number" [(ngModel)]="selectedTpr.assemblyPerc"
                    [disabled]="!selectedTpr.buildActualStart || disabled || reSourced  || inActive || !fieldAuthorized('assembly')"
                    (change)="onAssemblyPercChange(assemblyCheck)" name="assemblyInput"
                    pattern="^$|^([0-9]|[1-9][0-9]|[1][0][0])?" required #assemblyInput="ngModel" />
                <div *ngIf="assemblyInput.errors && (assemblyInput.dirty || assemblyInput.touched)">
                    <div class="error-hint" [hidden]="!assemblyInput.errors.pattern">
                        Number should be between 0 and 100
                    </div>
                </div>
            </mat-form-field>
        </div>

    </mat-grid-tile>
    <mat-grid-tile colspan="2" class="align-items-inherit check-padding">
        <mat-checkbox #certifyCheck class="checkbox-format text-center checkbox-6b" color="primary"
            [checked]="selectedTpr.certPerc === 100"
            [disabled]="!selectedTpr.buildActualStart || disabled || reSourced  || inActive || !fieldAuthorized('cert')"
            (change)="onCertifyCheckChange($event)">
            Complete
        </mat-checkbox>
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label> 15% Certify:</mat-label>
            </span>
            <mat-form-field class="block no-underline bg-yellow">
                <input matInput class="input-wrapper" type="number" [(ngModel)]="selectedTpr.certPerc"
                    [disabled]="!selectedTpr.buildActualStart || disabled || reSourced  || inActive || !fieldAuthorized('cert')"
                    (change)="onCertifyPercChange(certifyCheck)" name="certInput"
                    pattern="^$|^([0-9]|[1-9][0-9]|[1][0][0])?" required #certInput="ngModel"/>
                <div *ngIf="certInput.errors && (certInput.dirty || certInput.touched)">
                    <div class="error-hint" [hidden]="!certInput.errors.pattern">
                        Number should be between 0 and 100
                    </div>
                </div>
            </mat-form-field>
        </div>

    </mat-grid-tile>
    <mat-grid-tile colspan="2" class="align-items-inherit check-padding">
        <mat-checkbox #finalAsmCheck class="checkbox-format text-center checkbox-6b" color="primary"
            [checked]="selectedTpr.finalAsmPerc === 100"
            [disabled]="!selectedTpr.buildActualStart || disabled || reSourced  || inActive || !fieldAuthorized('finalAsm')"
            (change)="onFinalCheckChange($event)">
            Complete
        </mat-checkbox>
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label> 15% Final Assembly:</mat-label>
            </span>
            <mat-form-field class="block no-underline bg-yellow" color="green">
                <input matInput class="input-wrapper" type="number" [(ngModel)]="selectedTpr.finalAsmPerc"
                    [disabled]="!selectedTpr.buildActualStart || disabled || reSourced  || inActive || !fieldAuthorized('finalAsm')"
                    (change)="onFinalPercChange(finalAsmCheck)" name="finalAsmInput"
                    pattern="^$|^([0-9]|[1-9][0-9]|[1][0][0])?" required #finalAsmInput="ngModel"/>
                <div *ngIf="finalAsmInput.errors && (finalAsmInput.dirty || finalAsmInput.touched)">
                    <div class="error-hint" [hidden]="!finalAsmInput.errors.pattern">
                        Number should be between 0 and 100
                    </div>
                </div>
            </mat-form-field>
        </div>

    </mat-grid-tile>
    <mat-grid-tile colspan="3" class="align-items-inherit">
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Scheduled Finish:</mat-label>
            </span>
            <mat-form-field class="no-underline body-wrapper block">
                <input matInput class="input-wrapper" [ngModel]="selectedTpr.buildSchedFinish | date:'M/d/y'" readonly
                    [disabled]="disabled || reSourced  || inActive || !fieldAuthorized('buildSchedFinish')" />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Actual Finish:</mat-label>
            </span>
            <mat-form-field class="display-field no-underline bg-yellow"
                matTooltip="Before entering an Actual Finish date, each phase must be 100% complete.  In addition, an Actual Start date must be entered.">
                <input matInput class="input-wrapper" [matDatepicker]="buildActualFinishDatepicker2"
                    [(ngModel)]="selectedTpr.buildActualFinish" (dateChange)="onActualFinishChanged()"
                    [disabled]="!actualFinishEnabled() || disabled || reSourced  || inActive || !fieldAuthorized('buildActualFinish')" />
                <mat-datepicker-toggle matSuffix [for]="buildActualFinishDatepicker2"></mat-datepicker-toggle>
                <mat-datepicker #buildActualFinishDatepicker2></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Forecast Finish:</mat-label>
            </span>
            <mat-form-field class="display-field no-underline bg-yellow">
                <input matInput class="input-wrapper" [matDatepicker]="forecastFinishDatepicker2"
                    [(ngModel)]="selectedTpr.buildForecast"
                    [disabled]="disabled || reSourced  || inActive || !fieldAuthorized('buildForecast')"
                    (dateChange)="onGenericFieldChange('buildForecast',selectedTpr.buildForecast)" />
                <mat-datepicker-toggle matSuffix [for]="forecastFinishDatepicker2"></mat-datepicker-toggle>
                <mat-datepicker #forecastFinishDatepicker2></mat-datepicker>
            </mat-form-field>
        </div>

    </mat-grid-tile>
</mat-grid-list>
<mat-divider></mat-divider>
<mat-grid-list [cols]="4" gutterSize="25px" rowHeight="60px" class="dimensions-spacing"> </mat-grid-list>